import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useCallback, useEffect, useState } from "react";
import DeliveryAreaAction from "../stores/actions/DeliveryAreaAction";
import ProfileAction from "../stores/actions/profileAction";
import { RootState } from "../stores";
type FormData = {
  id: number;
  state: string;
  amount: any;
  min_order_amount: any;
  city: any;
};

function AddDeliveryAreaModel({
  setCatModal,
  catModal,
  getDevAreaList,
  type,
  getDevAreaData,
}: any) {
  const { stateList } = useSelector((state: RootState) => state.profile);
  const { cityList } = useSelector((state: RootState) => state.profile);
  const handleClose = () => setCatModal(false);
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState<any>("");
  const [city, setCity] = useState<any>("");
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<FormData>();

  useEffect(() => {
    if (type === "update" && getDevAreaData) {
      setValue("id", getDevAreaData.id);
      setState(getDevAreaData.state);
      setCity(getDevAreaData.city);
      setValue("amount", getDevAreaData.amount);
      setValue("min_order_amount", getDevAreaData.min_order_amount);
    } else {
      setState("");
      setCity("");
      setValue("amount", "");
      setValue("min_order_amount", "");
    }
  }, [type, getDevAreaData, catModal]);

  const formHandleSubmit = async (data: any) => {
    setLoading(true);
    try {
      if (type === "add") {
        var DevAreaData = await dispatch(
          DeliveryAreaAction.addDeliveryArea({
            state: state,
            city: city,
            amount: data.amount,
            min_order_amount: data.min_order_amount,
          })
        );
      } else {
        var DevAreaData = await dispatch(
          DeliveryAreaAction.updateDeliveryArea({
            id: data.id,
            state: state,
            city: city,
            amount: data.amount,
            min_order_amount: data.min_order_amount,
          })
        );
      }

      if (DevAreaData.status === false) {
        toast.error(DevAreaData.msg);
        setLoading(false);
      } else {
        setLoading(false);
        reset();
        handleClose();
        getDevAreaList();
        toast.success(DevAreaData.msg);
      }
    } catch (error) {
      handleClose();
      setLoading(false);
    }
  };

  const getStateList = useCallback(async () => {
    await dispatch(ProfileAction.getState());
  }, [dispatch]);

  const getcityList = useCallback(async () => {
    await dispatch(
      ProfileAction.getCity({
        state_id: state,
      })
    );
  }, [dispatch, state]);

  useEffect(() => {
    getStateList();
    getcityList();
  }, [getStateList, getcityList]);

  return (
    <div className="modal" style={{ display: catModal ? "block" : "none" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form
            className="needs-validation"
            onSubmit={handleSubmit(formHandleSubmit)}
            encType="multipart/form-data">
            <div className="modal-header">
              <h5 className="modal-title">
                {type === "add" ? "Add new" : "Update"} Delivery Area
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}></button>
            </div>
            <div className="modal-body">
              <div className="form-validation">
                <div className="row mb-3">
                  <div className="col-lg-12">
                    <label className="form-label">State</label>
                    <select
                      className="select2 form-select"
                      value={state}
                      onChange={(e) => setState(e.target.value)}>
                      <option value="" disabled selected hidden>
                        Select State
                      </option>
                      {stateList?.map((item: any, index: number) => (
                        <option key={index} value={item.name + "|" + item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label className="form-label">City</label>
                    <select
                      className="select2 form-select"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}>
                      <option value="" disabled selected hidden>
                        Select City
                      </option>
                      {cityList?.map((item: any, index: number) => (
                        <option key={index} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label className="form-label">Delivery Charges</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-name"
                      placeholder="Enter Delivery Charges"
                      {...register("amount")}
                    />
                  </div>
                  <div className="col-lg-12">
                    <label className="form-label">Minimum Order Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-name"
                      placeholder="Enter Minimum Order Amount"
                      {...register("min_order_amount")}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
                disabled={loading}
                onClick={handleClose}>
                Close
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary px-4">
                {loading ? <i className={"fa fa-spinner fa-spin"}></i> : null}
                &nbsp; {type == "add" ? "Save" : "Update"} Delivery Area
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddDeliveryAreaModel;
function setCategory(value: any) {
  throw new Error("Function not implemented.");
}

function setDeliveryArea(value: any) {
  throw new Error("Function not implemented.");
}
